export default __webpack_public_path__ + "static/media/72.c0e2dfa4.svg";